export default "__VITE_ASSET__BSolYObO__"